import React, {Fragment} from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SFXButtonComponent from "./SFXButtonComponent";
import ItemAssignmentComponent from "./ItemAssignmentComponent";

export default class ItemAssignmentButton extends React.Component {

  constructor(props) {
    super(props);

    this.assignRef = null;

    this.state = {
      isModalOpen: false
    }
  }

  toggleModal() {

    this.setState({
      isModalOpen: !this.state.isModalOpen
    })
  }

  btnAssignClick() {

    let selectedIds = this.assignRef.getSelectedIds();

    if (this.props.onItemsAssigned) {
      this.props.onItemsAssigned(selectedIds);
    }

    this.toggleModal();
  }

  render() {

    return <Fragment>
      {this.renderItemAssignmentModal()}
      <SFXButtonComponent
        onClick={() => this.toggleModal()}
      >
        {this.props.buttonText}
      </SFXButtonComponent>
    </Fragment>
  }

  renderItemAssignmentModal() {

    return <Modal
      isOpen={this.state.isModalOpen}
      className={'modal-primary modal-lg'}
    >
      <ModalHeader>
        {this.props.modalHeaderText || "Assign Items"}
      </ModalHeader>
      <ModalBody>
        <ItemAssignmentComponent
          ref={(ref) => {
            this.assignRef = ref;
          }}
          items={this.props.items}
          itemsAssigned={this.props.assignedItems}
          dataFieldId={this.props.assignmentDataFieldId || "id"}
          dataFieldName={this.props.assignmentDataFieldName || "displayName"}
          dataFieldDescription={this.props.assignmentDataFieldDescription || "description"}
          readOnly={this.props.readOnly}
        />
      </ModalBody>
      <ModalFooter>
        {!this.props.readOnly &&
          <SFXButtonComponent
            onClick={() => {
              this.btnAssignClick()
            }}
          >
            {this.props.assignButtonText || "Assign"}
          </SFXButtonComponent>
        }
        <SFXButtonComponent
          onClick={() => this.toggleModal()}
        >
          {this.props.cancelButtonText || "Cancel"}
        </SFXButtonComponent>
      </ModalFooter>
    </Modal>
  }
}
